/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { JunctionBoxFamilyInformationModule } from './junction-box-family-information.module';
export { JunctionBoxFamilyInformation } from './junction-box-family-information.component';